export enum PaymentMeansEnum {
  CHEQUE = 'CHEQUE',
  BANK_TRANSFER = 'BANK_TRANSFER',
  CREDIT_CARD = 'CREDIT_CARD'
}

export const paymentMeansEnumMapping: Record<PaymentMeansEnum, string> = {
  [PaymentMeansEnum.CHEQUE]: 'Chèque',
  [PaymentMeansEnum.BANK_TRANSFER]: 'Virement',
  [PaymentMeansEnum.CREDIT_CARD]: 'Carte bancaire'
}
